module.exports = __webpack_public_path__ + "static/media/any-provider.c1f5b2bb.png";